<div>
  <div style="margin-top: 5%" class="description-container font-text-bold description-title">
    <div *ngIf="!!result.orderIds; else confirmError">
      <h1 class="validIcon">
        <em class="fas fa-check-circle"></em>
      </h1>
      <h1 class="message">
        {{this.result.messageText}}
      </h1>
    </div>
    <ng-template #confirmError>
      <h1 class="errorIcon">
        <em class="far fa-times-circle"></em>
      </h1>
      <h1 class="message">
        {{this.result.messageText}}
      </h1>
    </ng-template>
    <h1 class="displayCenter">
      {{'ORDER-CONFIRM-REJECT.REDIRECT-MESSAGE' | translate}}
    </h1>
    <div *ngIf="timeoutId > 0" class="lds-dual-ring loadingSign"></div>
  </div>
</div>